// 图片元素的覆层组件
import React from 'react';
import { getWrappedOverlayer } from '@starflow/app/extension';

export const GroupOverlayerInner = ({ isExactlySelected }) => {
  if (!isExactlySelected) return null;

  return null;

  return (
    <div className="absolute top-full left-1/2 -translate-x-1/2">
      <div className="flex items-center justify-center px-4 h-8 bg-white shadow-light rounded pointer-events-auto">
        <span className="text-xs text-[#2d2d2d]">群组工具栏</span>
      </div>
    </div>
  );
};

export const GroupOverlayer = React.memo((props) => {
  const { isExactlySelected, isHovering, isMiniMode } = props;

  const WrapperOverLayer = getWrappedOverlayer('group', GroupOverlayerInner);

  return (
    <WrapperOverLayer
      {...props}
      isMiniMode={isMiniMode}
      isHovering={isHovering}
      isExactlySelected={isExactlySelected}
    />
  );
});
